import styled from "styled-components";
import theme from "../../../theme";

const { colors, fonts } = theme;

const Title = styled.h1`
  font-family: ${fonts.body};
  color: ${colors.secondary};
  font-family: "Playfair Display";
  font-size: 30px;
  font-weight: bold;
  letter-spacing: -0.23px;
  line-height: 37px;

  @media (min-width: 768px) {
    font-size: 40px;
    letter-spacing: -0.31px;
    line-height: 35px;
    font-weight: 700;
  }
`;
Title.displayName = "Title";

export default Title;
